module.exports = __webpack_public_path__ + "plus/img/18d22575698883bb22fa6b570348777d.png";


//////////////////
// WEBPACK FOOTER
// ./src/deps/public/footer4.png
// module id = WQ41
// module chunks = 6